import { type HeaderColumn } from "../../../../../../types/FilterTable";

export const headers: HeaderColumn[] = [
  { label: "Account ID", value: "accountId" },
  { label: "Monthly savings", value: "estimation" },
  { label: "Date enabled", value: "enabledDate" },
  { label: "", value: "" },
];
